<script setup>
import {usePortalContentAndDesignStore} from "../../../../../../../stores/partners/portalContentAndDesignStore";
import EditableTextField from "../../../../../portal-editable-fields/EditableTextField.vue";
import Btn from "../../../../../../../elements/Btn.vue";
import {useLogin} from "../../../../../../../composables/partners/useLogin";
import Alert from "../../../../../../../elements/Alert.vue";
import FormErrors from "../../../Errors/FormErrors.vue";


const portalContentAndDesignStore = usePortalContentAndDesignStore();

const { initOtp } = useLogin()
const { submitLogin } = useLogin();
</script>

<template>
    <div id="otp-form">
        <div class="mb-6 space-y-4">

            <form-errors :store-form-errors="portalContentAndDesignStore.loginFormErrors">
                <template #action>
                    <btn v-if="portalContentAndDesignStore.loginFormErrors?.responseError === 'Token not found or expired'"
                         type="secondary" size="small" @click.prevent="initOtp"
                         class="ml-2"
                    >
                        Resend token
                    </btn>
                </template>
            </form-errors>
            <alert v-if="portalContentAndDesignStore.loginFormData.otpIniSuccessMessage"
                   type="success"
            >
                {{ portalContentAndDesignStore.loginFormData.otpIniSuccessMessage }}
            </alert>

            <div class="space-y-4">
                <editable-text-field
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_email"
                    for-attribute="email"
                    class="block text-sm opacity-80 mb-1.5"
                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                    text-type="label"
                >
                </editable-text-field>
                <input
                    type="email"
                    name="email"
                    id="email"
                    v-model="portalContentAndDesignStore.loginFormData.email"
                    :disabled="!!portalContentAndDesignStore.loginFormData.otpIdentifier"
                    :required="true"
                    :class="portalContentAndDesignStore.getInputStyle"
                    @keyup.enter="submitLogin"
                >

                <!-- OTP Token -->
                <div v-if="portalContentAndDesignStore.loginFormData.otpIdentifier">
                    <editable-text-field
                        for-attribute="token"
                        :class="[
                            'block text-sm opacity-80 mb-1.5',
                            portalContentAndDesignStore.getPageContentTextColorClass
                        ]"
                        text-type="label"
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_OTP"
                    />
                    <input
                        type="password"
                        name="token"
                        id="token"
                        v-model="portalContentAndDesignStore.loginFormData.token"
                        required
                        :class="portalContentAndDesignStore.getInputStyle"
                        @keyup.enter="submitLogin"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
